export var ApplePayEventTypeEnumsObj = {
    SDK_NOT_INITIALIZED: "SDK_NOT_INITIALIZED",
    PAYMENT_SESSION_CANCELED: "PAYMENT_SESSION_CANCELED",
    PAYMENT_SESSION_ABORTED_BY_SDK: "PAYMENT_SESSION_ABORTED_BY_SDK",
    BUTTON_RENDERED: "BUTTON_RENDERED",
    BUTTON_NOT_RENDERED_ALREADY_EXISTS: "BUTTON_NOT_RENDERED_ALREADY_EXISTS",
    BUTTON_RENDER_FAIL_DEVICE_NOT_ELIGIBLE: "BUTTON_RENDER_FAIL_DEVICE_NOT_ELIGIBLE",
    BUTTON_RENDER_ERROR: "BUTTON_RENDER_ERROR",
    BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS: "BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS",
    BUTTON_CLICK: "BUTTON_CLICK",
    DEVICE_READY_TO_PAY: "DEVICE_READY_TO_PAY",
    DEVICE_NOT_READY_TO_PAY: "DEVICE_NOT_READY_TO_PAY",
    SDK_INITIALIZE_SUCCESS: "SDK_INITIALIZE_SUCCESS",
    SDK_INITIALIZE_ERROR: "SDK_INITIALIZE_ERROR",
    SDK_INITIALIZE_FAIL_DEVICE_NOT_ELIGIBLE: "SDK_INITIALIZE_FAIL_DEVICE_NOT_ELIGIBLE",
    SDK_INITIALIZE_FAIL_INITPARAMS_NOT_DEFINED: "SDK_INITIALIZE_FAIL_INITPARAMS_NOT_DEFINED",
    WALLET_SESSION_CREATION_STARTED: "WALLET_SESSION_CREATION_STARTED",
    WALLET_SESSION_CREATED: "WALLET_SESSION_CREATED",
    WALLET_SESSION_CREATION_FAIL: "WALLET_SESSION_CREATION_FAIL",
    MERCHANT_VALIDATION_STARTED: "MERCHANT_VALIDATION_STARTED",
    MERCHANT_VALIDATION_ERROR: "MERCHANT_VALIDATION_ERROR",
    MERCHANT_VALIDATION_COMPLETE: "MERCHANT_VALIDATION_COMPLETE",
    PAYMENT_COMPLETION_STARTED: "PAYMENT_COMPLETION_STARTED",
    PAYMENT_COMPLETION_ERROR: "PAYMENT_COMPLETION_ERROR",
    PAYMENT_COMPLETION_OK: "PAYMENT_COMPLETION_OK",
    PAYMENT_COMPLETION_NOK: "PAYMENT_COMPLETION_NOK",
    PAYMENT_METHOD_SELECTED: "PAYMENT_METHOD_SELECTED",
    SHIPPING_CONTACT_SELECTED: "SHIPPING_CONTACT_SELECTED",
    SHIPPING_METHOD_SELECTED: "SHIPPING_METHOD_SELECTED",
};
